'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'NotificationMessage',

    getInitialState: function getInitialState() {
        return { isShowing: true };
    },
    hideNotification: function hideNotification() {
        this.props.handleRemove();
        this.setState({ isShowing: false });
    },
    getClassName: function getClassName() {
        var className = this.props.notification.data.class_name || 'info';
        className += this.state.isShowing ? ' notification-enter' : ' notification-leave';
        return className;
    },
    render: function render() {

        var notification = this.props.notification;
        var className = this.getClassName();
        var styles = this.props.style;
        var text = {
            '__html': notification.data.text || '' // NOTE: We trust this content since it's hard-coded messages
        };

        return _react2['default'].createElement(
            'div',
            { id: notification.id, className: className, style: styles },
            _react2['default'].createElement(
                'div',
                { className: 'columns small-12 text-center' },
                _react2['default'].createElement(
                    'div',
                    { className: 'l-vertical-align-wrapper' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'l-vertical-align' },
                        _react2['default'].createElement(
                            'span',
                            { className: 'm-notification--close', onClick: this.hideNotification },
                            '\xD7'
                        ),
                        _react2['default'].createElement(
                            'p',
                            null,
                            _react2['default'].createElement(
                                'strong',
                                null,
                                notification.data.header
                            )
                        ),
                        _react2['default'].createElement('p', { dangerouslySetInnerHTML: text })
                    )
                )
            )
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/notifications/message.jsx
 ** module id = 715
 ** module chunks = 0 1
 **/